import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { SiteProvider } from './context/SiteContext';
import { AuthProvider } from './context/AuthContext';

// Public Components
import HomePage from './components/public/HomePage';
import DynamicPage from './components/public/DynamicPage';

// Admin Components
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminSettings from './components/admin/AdminSettings';
import AdminProducts from './components/admin/AdminProducts';
import AdminPages from './components/admin/AdminPages';
import AdminReviews from './components/admin/AdminReviews';
import AdminMedia from './components/admin/AdminMedia';
import AdminNavigation from './components/admin/AdminNavigation';
import AdminSEO from './components/admin/AdminSEO';
import AdminAI from './components/admin/AdminAI';
import ProtectedRoute from './components/admin/ProtectedRoute';

// Font imports
import '@fontsource/oswald/400.css';
import '@fontsource/oswald/500.css';
import '@fontsource/oswald/600.css';
import '@fontsource/oswald/700.css';
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/500.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/playfair-display/400-italic.css';
import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin Routes */}
          <Route path="/bambam/login" element={<AdminLogin />} />
          <Route
            path="/bambam"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="pages" element={<AdminPages />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="navigation" element={<AdminNavigation />} />
            <Route path="seo" element={<AdminSEO />} />
            <Route path="ai" element={<AdminAI />} />
          </Route>

          {/* Public Routes */}
          <Route
            path="/"
            element={
              <SiteProvider>
                <HomePage />
              </SiteProvider>
            }
          />
          <Route
            path="/page/:slug"
            element={
              <SiteProvider>
                <DynamicPage />
              </SiteProvider>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
